<template>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 flex-grow">
    <div class="">
      <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
        <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
          <dt class="text-sm font-medium text-gray-500 truncate">
            {{ $t('statistics.totalConversations') }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold text-indigo-600">
            {{totalConversations}}
          </dd>
        </div>
        <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
          <dt class="text-sm font-medium text-gray-500 truncate">
            {{ $t('statistics.totalActiveConversations') }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold text-red-600">
            {{totalActiveConversations}}
          </dd>
        </div>
        <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
          <dt class="text-sm font-medium text-gray-500 truncate">
            {{ $t('statistics.totalResolvedConversations') }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold text-green-600">
            {{totalClosedConversations}}
          </dd>
        </div>
      </dl>
    </div>
    <div class="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <ChatIcon  class="h-9 w-9 text-gray-600 fill-gray-600" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  {{ $t('statistics.totalMessages') }}
                </dt>
                <dd>
                  <div class="text-lg font-medium text-gray-900">
                    {{totalMessages}}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-5 py-3">
          <div class="text-sm">
            <a href="#" class="font-medium text-indigo-500 hover:text-indigo-700">
              <VLink href="/conversations">{{ $t('statistics.viewChat') }}</VLink>
            </a>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <AgentsIcon class="h-9 w-9 text-gray-600 fill-gray-600" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  {{ $t('statistics.totalAgents') }}
                </dt>
                <dd>
                  <div class="text-lg font-medium text-gray-900">
                    {{totalAgents}}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-5 py-3">
          <div class="text-sm">
            <a href="#" class="font-medium text-indigo-500 hover:text-indigo-700">
              <VLink href="/agents">{{ $t('statistics.viewAgents') }}</VLink>
            </a>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <CustomersIcon  class="h-9 w-9 text-gray-600 fill-gray-600" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  {{ $t('statistics.totalCustomers') }}
                </dt>
                <dd>
                  <div class="text-lg font-medium text-gray-900">
                    {{totalCustomers}}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-5 py-3">
          <div class="text-sm">
            <a href="#" class="font-medium text-indigo-500 hover:text-indigo-700">
              <VLink href="/customers">{{ $t('statistics.viewCustomers') }}</VLink>
            </a>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <SettingsIcon  class="h-9 w-9 text-gray-600 fill-gray-600" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  {{ $t('statistics.totalChannels') }}
                </dt>
                <dd>
                  <div class="text-lg font-medium text-gray-900">
                    {{totalChannels}}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-5 py-3">
          <div class="text-sm">
            <a href="#" class="font-medium text-indigo-500 hover:text-indigo-700">
              <VLink href="/settings/facebook">{{ $t('statistics.viewSettings') }}</VLink>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <messagesByChannel />
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <messagesByAgent />
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <reasonsForResolving />
        </div>
      </div>
    </div>
    <div class="bg-white overflow-hidden shadow rounded-lg mt-7 mb-7">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" colspan="2">{{$t("agent.name")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">{{$t("agent.active")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">{{$t("statistics.resolveReason")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">{{$t("statistics.messagesSent")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">{{$t("statistics.avgMessagePerConv")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">{{$t("statistics.avgResponseTime")}}</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="agent of agentStore.collection" v-bind:key="agent.id">
            <AgentStatisticsItem :agent="agent" />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ChatIcon from '../components/page/icons/ChatIcon.vue'
import CustomersIcon from '../components/page/icons/CustomersIcon.vue'
import AgentsIcon from '../components/page/icons/AgentsIcon.vue'
import SettingsIcon from '../components/page/icons/SettingsIcon.vue'
import VLink from './page/VLink.vue'
import messagesByChannel from './statistics/messagesByChannel.vue'
import messagesByAgent from './statistics/messagesByAgent.vue'
import reasonsForResolving from './statistics/reasonsForResolving.vue'
import AgentStatisticsItem from '@/components/statistics/agentStatisticsItem';

import { useConversationsStore } from '@/stores/conversations'
import { useAgentStore } from '@/stores/agents'
import { useCustomerStore } from '@/stores/customers'
import { useFanpagesStore } from '@/stores/fanpages';
import { useAgentAverageStatistics } from '@/stores/agentAverageStatistics';
import { useReasonForResolvingStatisticsStore } from '@/stores/reasonForResolvingAgentStatistics';
import agentsAverageModel from '@/models/agents-by-average'
import reasonForResolvingModel from '@/models/reasons-for-resolving-statistics'


export default {
  name: 'StatisticsPage',
  components: {
    AgentStatisticsItem,
    ChatIcon,
    AgentsIcon,
    SettingsIcon,
    CustomersIcon,
    VLink,
    messagesByChannel,
    messagesByAgent,
    reasonsForResolving,
  },
  setup() {
    let conversationsStore = useConversationsStore();
    let agentStore = useAgentStore();
    let customerStore = useCustomerStore();
    let fanpagesStore = useFanpagesStore();
    let agentAverageStatistics = useAgentAverageStatistics();
    let agentResolvingStatistics = useReasonForResolvingStatisticsStore();
    return { conversationsStore, agentStore, customerStore, fanpagesStore, agentAverageStatistics, agentResolvingStatistics };
  },
  async created() {
    await this.fetchAgentAverageStatistics();
    await this.fetchAgentResolvingStatistics();
    this.$root.messageEmit('closed_conversations_requested', this.$root.token);
  },
  computed: {
    totalConversations() {
      return this.conversationsStore.collection.length;
    },
    totalClosedConversations() {
      let closed = this.conversationsStore.collection.filter(c => {
        return c.status === 'closed';
      });
      let count = closed.length;
      if (count) {
        return count;
      } else {
        return 0;
      }
    },
    totalActiveConversations() {
      return this.totalConversations - this.totalClosedConversations;
    },
    totalAgents() {
      return this.agentStore.collection.length;
    },
    totalCustomers() {
      return this.customerStore.collection.length;
    },
    totalChannels() {
      return this.fanpagesStore.collection.length;  // + WHATSAPP
    },
    totalMessages() {
      let total = 0;
      this.conversationsStore.collection.forEach(c => {
        total += c['messages_count'];
      });
      return total;
    },
  },
  methods: {
    async fetchAgentAverageStatistics() {
      let dataset = await agentsAverageModel.getAgentsByAverageStatistics(this.axios, this.$root.token);
      dataset.data.data.forEach(row => {
        this.agentAverageStatistics.replaceOrAdd(row);
      });
    },
    async fetchAgentResolvingStatistics() {
      let dataset = await reasonForResolvingModel.getAgentStatistics(this.axios, this.$root.token);
      dataset.data.data.forEach(row => {
        this.agentResolvingStatistics.replaceOrAdd(row);
      });
    }
  }
}
</script>
